import React, {useEffect, useRef, useState} from 'react'
import {observer} from "mobx-react";
import {Button, Input, Menu, MenuItem, Tab, Tabs} from "@mui/material";
import {fileTypeEnum, responseEnum} from "../../serverClientShared/sharedEnums";
import Divider from "@mui/material/Divider";
import ItemsPreview from "./ItemsPreview";
import Utility from "../../Utility";
import {itemTypeEnum, modalActionTypeEnum} from "../../enums";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Drop from "../DragDrop/Drop";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {filter3DFilesBeforeUpload, fusionTypes} from "../../serverClientShared/sharedUtils";
import {useBackDrop, useStores} from "../../Hooks";
import EllipsisContainer from "../Shared/EllipsisContainer";
import axios from "axios";
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Draggable from 'react-draggable';
import Checkbox from '@mui/material/Checkbox';
import RichObjectTreeView from "./TreeView";
import TabPanel from "./TabPanel";
import DeleteIcon from "@mui/icons-material/Delete";

const MediaLibrary = observer(() => {
    const [allFilesParentsMap, setAllFilesParentsMap] = useState(new Map());
    const [allFoldersParentsMap, setAllFoldersParentsMap] = useState(new Map());
    const [tabIndex, setTabIndex] = useState(0);
    const [currentFolderFiles, setCurrentFolderFiles] = useState([]);
    const [currentFolderFilesSearch, setCurrentFolderFilesSearch] = useState([]);
    const [currentFolderFolders, setCurrentFolderFolders] = useState([]);
    const [currentFolderFoldersSearch, setCurrentFolderFoldersSearch] = useState([]);
    const [folderImages, setFolderImages] = useState([]);
    const [folderVideos, setFolderVideos] = useState([]);
    const [folderPdfs, setFolderPdfs] = useState([]);
    const [folder3ds, setFolder3ds] = useState([]);
    const [folderFusions, setFolderFusions] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedFolders, setSelectedFolders] = useState([]);
    const [mouseX, setMouseX] = useState(null);
    const [mouseY, setMouseY] = useState(null);
    const [rightClickedItem, setRightClickedItem] = useState(null);
    const {projectStore, modalStore, procedureStore, generalStore, dragStore, editorStore} = useStores();
    const [searchItems, setSearchItems] = useState('');
    const [allFiles, setAllFiles] = useState([]);
    const [allFolders, setAllFolders] = useState([]);
    const dropRef = useRef(null);
    const [panelWidth, setPanelWidth] = useState(300);
    const inputRef = useRef(null);
    const [searchInFolder, setSearchInFolder] = useState(true);
    const newFolderRef = useRef(null);

    const rootFolders = allFolders.filter(folder=>!folder.ParentFolder);

    // rootFolders.map(folder=>folder.ParentFolder = 'root');

    useBackDrop(
        dropRef,
        () => dragStore.isDraggingFiles = true,
        () => dragStore.isDraggingFiles = false,
        saveFileWith3dCheck,
    )

    useEffect(() => {
        (async function getItems() {
            generalStore.isLoaderOpen = true;
            await getFiles();
            inputRef.current.focus();
            generalStore.isLoaderOpen = false;
        })()
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setList();
        // eslint-disable-next-line
    }, [allFilesParentsMap, allFoldersParentsMap, tabIndex, selectedFiles]);

    const items = [
        ...selectedFiles.map(file => {
            file.type = itemTypeEnum.FILE;
            return file;
        }),
        ...selectedFolders.map(folder => {
            folder.type = itemTypeEnum.MEDIA_FOLDER;
            return folder;
        }),
    ];

    async function getFiles() {
        let projectId;
        if (projectStore?.currentProject?.ProjectIdentifier) {
            projectId = projectStore.currentProject?.ProjectIdentifier;
        } else if (procedureStore?.currentProcedure?.ProjectRef) {
            projectId = procedureStore.currentProcedure.ProjectRef;
        } else {
            console.error('missing project ref');
            return;
        }
        const {files, mediaFolders} = await projectStore.getAllProjectFilesAndFolders(projectId);
        setAllFiles(files);

        setAllFolders(mediaFolders);
        const selectedFiles = []

        const allFilesParentsMap = new Map();
        files.forEach(file => {
            const parentFolder = file.ParentFolder || 'root';
            const parentArr = allFilesParentsMap.get(parentFolder) || [];
            parentArr.push(file);
            allFilesParentsMap.set(parentFolder, parentArr);
            if (dragStore.selectedFilesIds.has(file.FileId)) {
                selectedFiles.push(file)
            }
        });
        const allFoldersParentsMap = new Map();
        mediaFolders.forEach(folder => {
            const parentFolder = folder.ParentFolder || 'root';
            const parentArr = allFoldersParentsMap.get(parentFolder) || [];
            parentArr.push(folder);
            allFoldersParentsMap.set(parentFolder, parentArr);
        });

        setAllFilesParentsMap(new Map(allFilesParentsMap));
        setAllFoldersParentsMap(new Map(allFoldersParentsMap));
        setTabIndex(0);
        setSelectedFiles([...selectedFiles]);
    }

    function openContextMenu(event, item) {
        event.preventDefault();
        setMouseX(event.clientX - 2);
        setMouseY(event.clientY - 4);
        setRightClickedItem(item);
    }

    function closeContextMenu(event) {
        event && event.preventDefault();
        setMouseX(null);
        setMouseY(null);
        setRightClickedItem(null);
    }

    function renderContextMenu() {
        return (
            <Menu
                keepMounted
                open={mouseY !== null}
                onClose={closeContextMenu}
                anchorReference="anchorPosition"
                anchorPosition={
                    mouseY !== null && mouseX !== null
                        ? {top: mouseY, left: mouseX}
                        : undefined
                }
            >
                <MenuItem onClick={renameItem}>{generalStore.translate('rename')}</MenuItem>
                <ConditionalComponent
                if={
                    rightClickedItem?.type === itemTypeEnum.FILE &&
                    !fusionTypes.includes(rightClickedItem?.FileType) &&
                    !modalStore.modalData.onMediaSelected
                }
            >
                <MenuItem onClick={downloadItem}>{generalStore.translate('download')}</MenuItem>
                </ConditionalComponent>
                    <Divider style={{color: "#C2C9DB", border: "1px solid #C2C9DB"}}/>
                    <MenuItem style={{color: "red"}} onClick={deleteItem}>  <DeleteIcon fontSize='small' color='error'/> <span style={{marginLeft: "5px", marginTop: "4px"}}>{generalStore.translate('delete')}</span></MenuItem>
            </Menu>
        )
    }

    function renameItem() {
        const currentModalData = modalStore.modalData;
        modalStore.modalData = {
            ...currentModalData,
            doMainAction: async (name) => {
                try {

                    const itemToBeChanged = modalStore.itemToBeChanged;
                    let status;
                    if (itemToBeChanged.type === itemTypeEnum.MEDIA_FOLDER) {
                        status = await generalStore.renameMediaFolder(itemToBeChanged._id, name);
                    } else {
                        status = await generalStore.renameFile(itemToBeChanged.FileId, name);
                    }
                    generalStore.isLoaderOpen = false;
                    if (status === responseEnum.OK) {
                        await refreshMediaLibrary();
                        return true;
                    } else {
                        return false
                    }
                } catch (e) {
                    modalStore.showErrorMessage(generalStore.translate('cannotRenameItem'))
                    return false;

                }
            },

            itemType: rightClickedItem.type,
            actionType: modalActionTypeEnum.RENAME,
            bodyText: generalStore.translate('renameItem'),
            placeholder: generalStore.translate('egPcTroubleshooting')
        };
        modalStore.itemToBeChanged = rightClickedItem;
        modalStore.isCreateRenameModalOpen = true;
        closeContextMenu();
    }

    function deleteItem() {
        modalStore.modalData.afterDelete = refreshMediaLibrary;
        modalStore.modalData.itemsToDelete = [rightClickedItem];
        modalStore.modalData.headerClassName = 'create-media-folder-header';
        modalStore.isDeleteMediaItemsModalOpen = true;
        closeContextMenu();
    }

    async function downloadItem() {
        closeContextMenu();
        if (rightClickedItem.type !== itemTypeEnum.FILE || fusionTypes.includes(rightClickedItem.FileType) || !!modalStore.modalData.onMediaSelected) {
            return;
        }

        const promise = async () => {
            const response = await axios({
                url: rightClickedItem.FileId,
                method: 'GET',
                responseType: 'blob',
            });
            const a = document.createElement('A');
            a.href = window.URL.createObjectURL(new Blob([response.data]));
            a.download = rightClickedItem.FileName + '.' + rightClickedItem.FileExtension;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
        const loadingMessage = generalStore.translate('downloading') + '...';
        const errorMessage = generalStore.translate('couldNotDownloadFile');
        await modalStore.runAsync(promise(), errorMessage, null, loadingMessage);
    }

    function setList() {
        const {no3d} = modalStore.modalData;
        const sortMethod = (fileA, fileB) => Utility.sortByString(fileA, fileB, "FileName");

        const foldersPathArray = projectStore.mediaLibraryPathArray
        const currentFolder = foldersPathArray[foldersPathArray.length - 1];
        const currentFolderFiles = (allFilesParentsMap.get(currentFolder.folderId) || [])
            .filter(file => {
                if (no3d) {
                    return ![fileTypeEnum.THREE_D, ...fusionTypes].includes(file.FileType)
                } else {
                    return true;
                }
            }).sort(sortMethod);

        const currentFolderFolders = allFoldersParentsMap.get(currentFolder.folderId) || [];
        const folderImages = searchItems.length > 0 ? currentFolderFilesSearch.filter(file => file.FileType === fileTypeEnum.IMAGE) : currentFolderFiles.filter(file => file.FileType === fileTypeEnum.IMAGE);
        const folderVideos = searchItems.length > 0 ? currentFolderFilesSearch.filter(file => file.FileType === fileTypeEnum.VIDEO) : currentFolderFiles.filter(file => file.FileType === fileTypeEnum.VIDEO);
        const folderPdfs = searchItems.length > 0 ? currentFolderFilesSearch.filter(file => file.FileType === fileTypeEnum.PDF) : currentFolderFiles.filter(file => file.FileType === fileTypeEnum.PDF);
        const folder3ds = searchItems.length > 0 ? currentFolderFilesSearch.filter(file => file.FileType === fileTypeEnum.THREE_D) : currentFolderFiles.filter(file => file.FileType === fileTypeEnum.THREE_D);
        const folderFusions = searchItems.length > 0 ? currentFolderFilesSearch.filter(file => fusionTypes.includes(file.FileType)) : currentFolderFiles.filter(file => fusionTypes.includes(file.FileType));

        setCurrentFolderFiles([...currentFolderFiles]);
        setCurrentFolderFolders([...currentFolderFolders]);
        setFolderImages([...folderImages]);
        setFolderVideos([...folderVideos]);
        setFolderPdfs([...folderPdfs]);
        setFolder3ds([...folder3ds]);
        setFolderFusions([...folderFusions]);
    }

    function changeTab(event, newValue) {
        setTabIndex(newValue);
        setSearchItems('');
    }

    function renderTabs() {
        const {onlyImages, only3d, onlyFusion, no3d} = modalStore.modalData;
        if (onlyImages) {
            return (
                <Tabs value={tabIndex} onChange={changeTab}>
                    <Tab label={`${generalStore.translate('images')} (${folderImages.length})`} tabIndex={0}/>
                </Tabs>
            )
        } else if (only3d || onlyFusion) {
            return (
                <Tabs value={tabIndex} onChange={changeTab}>
                    <Tab label={`${generalStore.translate('DigitalTwins')} (${folder3ds.length+folderFusions.length})`} tabIndex={0}/>
                </Tabs>
            )
        } else if (no3d) {
            return (
                <Tabs value={tabIndex} onChange={changeTab}>
                    <Tab
                        label={`${generalStore.translate('all')} (${currentFolderFiles.length + currentFolderFolders.length})`}
                        tabIndex={0}/>
                    <Tab label={`${generalStore.translate('images')} (${folderImages.length})`} tabIndex={1}/>
                    <Tab label={`${generalStore.translate('videos')} (${folderVideos.length})`} tabIndex={2}/>
                    <Tab label={`${generalStore.translate('pdf')} (${folderPdfs.length})`} tabIndex={3}/>
                </Tabs>
            )
        } else {
            return (
                <span style={{display: "flex", flexDirection: "row"}}>
                <Tabs textColor="inherit" value={tabIndex} onChange={changeTab}>
                    <Tab
                        label={`${generalStore.translate('all')} (${currentFolderFiles.length + currentFolderFolders.length})`}
                        tabIndex={0}/>
                     <Tab label={`${generalStore.translate('DigitalTwins')} (${folder3ds.length+folderFusions.length})`} tabIndex={1}/>
                    <Tab label={`${generalStore.translate('images')} (${folderImages.length})`} tabIndex={2}/>
                    <Tab label={`${generalStore.translate('videos')} (${folderVideos.length})`} tabIndex={3}/>
                    <Tab label={`${generalStore.translate('pdf')} (${folderPdfs.length})`} tabIndex={4}/>

                </Tabs>
                </span>
            )
        }

    }

    function onFilesSelected(files) {
        setSelectedFiles([...files]);
        dragStore.selectedFilesIds = new Set(files.map(file => file.FileId));
    }

    function onFoldersSelected(folders) {
        setSelectedFolders([...folders]);
        dragStore.selectedFoldersIds = new Set(folders.map(folder => folder._id));
    }

    function renderTabPanels() {
        const {onlyImages, only3d, onlyFusion, no3d} = modalStore.modalData;
        const sharedProps = {
            folders: searchItems.length > 0 ? currentFolderFoldersSearch : currentFolderFolders,
            onFilesSelected,
            onFoldersSelected,
            onFolderDoubled: goToFolder,
            openContextMenu
        }
        if (onlyImages) {
            return (
                <TabPanel
                    value={tabIndex}
                    index={0}
                    files={searchItems.length > 0 ? currentFolderFilesSearch.filter(file => file.FileType === fileTypeEnum.IMAGE) : folderImages}
                    {...sharedProps}
                    setSearchItems={setSearchItems}
                    searchItems={searchItems}
                    newFolder={newFolderRef}
                    panelWidth={panelWidth}
                />
            )
        } else if (only3d || onlyFusion) {
            return (
                <TabPanel
                    value={tabIndex}
                    index={0}
                    files={searchItems.length > 0 ? currentFolderFilesSearch.filter(file => file.FileType === fileTypeEnum.THREE_D ||  fusionTypes.includes(file.FileType)) : [...folder3ds, ...folderFusions]}
                    {...sharedProps}
                    searchItems={searchItems}
                    setSearchItems={setSearchItems}
                    newFolder={newFolderRef}
                    panelWidth={panelWidth}

                />
            )
        } else if (no3d) {
            return (
                <>
                    <TabPanel
                        value={tabIndex}
                        index={0}
                        files={searchItems.length > 0 ? currentFolderFilesSearch : currentFolderFiles}
                        {...sharedProps}
                        setSearchItems={setSearchItems}
                        newFolder={newFolderRef}
                        searchItems={searchItems}
                        panelWidth={panelWidth}

                    />
                    <TabPanel
                        value={tabIndex}
                        index={1}
                        files={searchItems.length > 0 ? currentFolderFilesSearch.filter(file => file.FileType === fileTypeEnum.IMAGE) : folderImages}
                        {...sharedProps}
                        setSearchItems={setSearchItems}
                        newFolder={newFolderRef}
                        searchItems={searchItems}
                        panelWidth={panelWidth}

                    />
                    <TabPanel
                        value={tabIndex}
                        index={2}
                        files={searchItems.length > 0 ? currentFolderFilesSearch.filter(file => file.FileType === fileTypeEnum.VIDEO) : folderVideos}
                        {...sharedProps}
                        setSearchItems={setSearchItems}
                        newFolder={newFolderRef}
                        searchItems={searchItems}
                        panelWidth={panelWidth}

                    />
                    <TabPanel
                        value={tabIndex}
                        index={3}
                        files={searchItems.length > 0 ? currentFolderFilesSearch.filter(file => file.FileType === fileTypeEnum.PDF) : folderPdfs}
                        {...sharedProps}
                        newFolder={newFolderRef}
                        setSearchItems={setSearchItems}
                        searchItems={searchItems}
                        panelWidth={panelWidth}

                    />
                </>
            )
        } else {
            return (
                <>
                    <TabPanel
                        value={tabIndex}
                        index={0}
                        files={searchItems.length > 0 ? currentFolderFilesSearch : currentFolderFiles}
                        {...sharedProps}
                        newFolder={newFolderRef}
                        setSearchItems={setSearchItems}
                        panelWidth={panelWidth}
                        searchItems={searchItems}

                    />
                    <TabPanel
                        value={tabIndex}
                        index={1}
                        files={searchItems.length > 0 ? currentFolderFilesSearch.filter(file => file.FileType === fileTypeEnum.THREE_D ||  fusionTypes.includes(file.FileType)) : [...folder3ds, ...folderFusions]}
                        {...sharedProps}
                        newFolder={newFolderRef}
                        setSearchItems={setSearchItems}
                        panelWidth={panelWidth}
                        searchItems={searchItems}

                    />
                    <TabPanel
                        value={tabIndex}
                        index={2}
                        files={searchItems.length > 0 ? currentFolderFilesSearch.filter(file => file.FileType === fileTypeEnum.IMAGE) : folderImages}
                        {...sharedProps}
                        newFolder={newFolderRef}
                        setSearchItems={setSearchItems}
                        panelWidth={panelWidth}
                        searchItems={searchItems}

                    />
                    <TabPanel
                        value={tabIndex}
                        index={3}
                        files={searchItems.length > 0 ? currentFolderFilesSearch.filter(file => file.FileType === fileTypeEnum.VIDEO) : folderVideos}
                        {...sharedProps}
                        newFolder={newFolderRef}
                        setSearchItems={setSearchItems}
                        panelWidth={panelWidth}
                        searchItems={searchItems}

                    />
                    <TabPanel
                        value={tabIndex}
                        index={4}
                        files={searchItems.length > 0 ? currentFolderFilesSearch.filter(file => file.FileType === fileTypeEnum.PDF) : folderPdfs}
                        {...sharedProps}
                        newFolder={newFolderRef}
                        setSearchItems={setSearchItems}
                        panelWidth={panelWidth}
                        searchItems={searchItems}

                    />
                </>
            )
        }

    }

    async function refreshMediaLibrary() {
        if (!modalStore.modalData.preventRefreshProject) {
            await projectStore.refreshProjectDetails();
        }

        if (modalStore.isMediaLibraryModalOpen) {
            modalStore.isMediaLibraryModalOpen = false;
            modalStore.isMediaLibraryModalOpen = true;
        }
    }

    async function saveSelection() {
        await modalStore.modalData.onMediaSelected(selectedFiles);
        dragStore.resetDragMedia();
        modalStore.isMediaLibraryModalOpen = false;
    }

    function isSaveDisabled() {
        return !selectedFiles.length || selectedFolders.length;
    }

    function openCreateFolderDialog() {
        const currentModalData = modalStore.modalData;
        modalStore.modalData = {
            ...currentModalData,
            doMainAction: async (name) => {
                try {
                    const foldersPathArray = projectStore.mediaLibraryPathArray;
                    const currentFolder = foldersPathArray[foldersPathArray.length - 1];
                    const newFolder = await projectStore.createMediaFolder(currentFolder.folderId, name);
                    newFolderRef.current = newFolder;
                    dragStore.selectedFoldersIds = new Set(newFolder._id);
                    setSelectedFolders([newFolder]);
                    await getFiles();
                } catch (e) {
                    modalStore.showErrorMessage(generalStore.translate('cannotCreateFolder'));
                    console.error(e);
                    return false;
                }
                return true;
            },

            itemType: itemTypeEnum.MEDIA_FOLDER,
            actionType: modalActionTypeEnum.CREATE,
            placeholder: generalStore.translate('nameFolder...'),
            headerClassName: 'create-media-folder-header'
        };

        modalStore.isCreateRenameModalOpen = true;
    }

    function openUploadMediaDialog() {
        generalStore.oldMediaFileToBeReplaced = null;
        modalStore.isUploadModalOpen = true;
    }

    function goToFolder(folderToGo, parentsFolders = [], fromCard=false) {
        const {folderId, folderName} = folderToGo;
        let foldersPathArray = projectStore.mediaLibraryPathArray;
        let alreadyInArray = false;
        if (parentsFolders.length ===0 && !fromCard){
            projectStore.mediaLibraryPathArray = [projectStore.mediaLibraryPathArray[0]];
            foldersPathArray = [projectStore.mediaLibraryPathArray[0]];
        }
        for (let i = 0; i < foldersPathArray.length; i++) {
            const currentFolderId = foldersPathArray[i].folderId;
            if (currentFolderId === folderId) {
                foldersPathArray = foldersPathArray.slice(0, i + 1);
                alreadyInArray = true;
                break;
            }
        }

        if (!alreadyInArray) {
            if(parentsFolders.length>0){
                for(let i=0; i<projectStore.mediaLibraryPathArray.length; i++){
                    const folderIdentifier = projectStore.mediaLibraryPathArray[i].folderId;
                    if(projectStore.mediaLibraryPathArray[i].folderId!=='root' && !parentsFolders.some(folder=>folder?.folderId===folderIdentifier))
                        foldersPathArray = foldersPathArray.filter(folder=>folder.folderId!==folderIdentifier);
                }
            }
            if (parentsFolders.length > 0) {
                for (let k = 0; k < parentsFolders.length; k++)
                  if(foldersPathArray.filter(fold=>fold.folderId=== parentsFolders[k].folderId).length===0)
                    foldersPathArray.push({
                        folderId: parentsFolders[k].folderId,
                        folderName: parentsFolders[k].folderName
                    });
            }
            foldersPathArray.push({
                folderId,
                folderName
            });
        }

        projectStore.mediaLibraryPathArray = foldersPathArray;
        setList();
    }

    function renderBreadCrumbs() {
        const foldersPathArray = projectStore.mediaLibraryPathArray;
        const separator = <KeyboardArrowRightIcon className='breadcrumb'/>;
        return (
            <Breadcrumbs separator={separator} className='media-breadcrumbs'>
                {foldersPathArray.map((folder, index) => {
                    const folderName = folder.folderName === 'Root' ? generalStore.translate('ProjectMediaManager') : folder.folderName;
                    const isLast = index === foldersPathArray.length - 1;
                    return (
                        <Drop itemId={folder.folderId} key={folder.folderId}>
                            <EllipsisContainer value={folderName}>
                                <div className={isLast ? 'breadcrumb last' : 'breadcrumb'} onClick={() => {
                                    goToFolder(folder, [], true);
                                    setSearchItems('')
                                }}>
                                    {folderName}
                                </div>
                            </EllipsisContainer>
                        </Drop>
                    );
                })}
                {foldersPathArray.length === 1 ? <div className='breadcrumb fake-breadcrumb'/> : null}
            </Breadcrumbs>
        )
    }

    async function onUploadSuccess(files) {
        dragStore.selectedFilesIds = new Set()
        files.forEach(file => {
            dragStore.selectedFilesIds.add(file.FileId);
            dragStore.recentlyUploadedFiles.add(file);
        });

        modalStore.isUploadModalOpen = false;
        if (!modalStore.modalData.preventRefreshProject) {
            await projectStore.refreshProjectDetails();
            editorStore.refreshTriger = !editorStore.refreshTriger;
        }
        if (modalStore.isMediaLibraryModalOpen) {
            modalStore.isMediaLibraryModalOpen = false;
            modalStore.isMediaLibraryModalOpen = true;
        }
    }

    async function saveFile(files) {


        generalStore.isLoaderOpen = true;
        try {
            const foldersPathArray = projectStore.mediaLibraryPathArray;
            const currentFolder = foldersPathArray[foldersPathArray.length - 1];
            const currentFolderId = currentFolder.folderId;
            let projectId;
            if (projectStore?.currentProject?.ProjectIdentifier) {
                projectId = projectStore.currentProject?.ProjectIdentifier;
            } else if (procedureStore.currentProcedure?.ProjectRef) {
                projectId = procedureStore.currentProcedure.ProjectRef;
            } else {
                console.error('missing project ref');
                return;
            }

            const associatedFiles = await generalStore.uploadFiles(files, projectId, currentFolderId);
            await onUploadSuccess(associatedFiles);
        } catch (e) {
            console.error(e);
            if (e.response) {
                if (e.response.status === responseEnum.PAYLOAD_TOO_LARGE) {
                    modalStore.showErrorMessage('File is too large! (>500 MB)');
                } else if (e.response.status === responseEnum.NO_PERMISSION) {
                    modalStore.showErrorMessage(generalStore.translate('cannotUploadFileOfThisType'));
                }
            } else {
                modalStore.showErrorMessage(generalStore.translate('problemUploadingFile'));
            }
        }
    }

    async function saveFileWith3dCheck (files) {
        let errorMessage = null;
        if(modalStore.modalData.no3d){
            const filter3DFilesResponse = filter3DFilesBeforeUpload(files)
            errorMessage = filter3DFilesResponse.errorMessage;
            const filteredFiles = filter3DFilesResponse.files
            if(errorMessage){
                modalStore.showErrorMessage(errorMessage, true);
            }
            if(filteredFiles === null){
                return;
            }
            files = filteredFiles;
        }
        generalStore.isLoaderOpen = true;
        await saveFile(files)
        if(errorMessage) {
            modalStore.showErrorMessage(errorMessage, true);
        }
    }

    const handleDrag = (e, data) => {
        if(panelWidth+data.deltaX<600 && panelWidth+data.deltaX >239)
        setPanelWidth((prevWidth) => prevWidth + data.deltaX);
    };


    const searchFilesInCurrentFolderAndSubfolders = (searchTerm, folders, files, currentFolderId) => {
        const filesResults = [];
        const foldersResults = [];

        const searchInFolder = (folderId) => {
            const filesInFolder = files.filter((file) => file?.ParentFolder === folderId);
            const foldersInFolder = folders.filter((folder) => folder?.ParentFolder === folderId);
            const filesSearchResults = filesInFolder.filter((file) =>
                file.FileName.toLowerCase().includes(searchTerm.toLowerCase())
            );
            const foldersSearchResults = foldersInFolder.filter((folder) =>
                folder.FolderName.toLowerCase().includes(searchTerm.toLowerCase())
            );
            filesResults.push(...filesSearchResults);
            foldersResults.push(...foldersSearchResults);
            const subfolders = allFoldersParentsMap.get(folderId);
            subfolders?.forEach((subfolder) => searchInFolder(subfolder._id));
        };
        searchInFolder(currentFolderId);
        return {filesResults, foldersResults};
    };
    const foldersPathArray = projectStore.mediaLibraryPathArray;
    const currentFolder = foldersPathArray[foldersPathArray.length - 1];

    return (
        <div className="media-container content" ref={dropRef}>
            <div style={{display: "flex", justifyContent: "space-between", flexDirection: "row"}}>
                <div className='breadcrumb'>
                    {renderBreadCrumbs()}

                </div>
                <span style={{display: "flex", justifyContent: "flex-end", marginRight: "25px"}}>

                    <span>
                        <CreateNewFolderOutlinedIcon
                            onClick={openCreateFolderDialog}
                            fontSize='large'
                            style={{marginRight: "28px", cursor: "pointer"}}
                        />
                        <Button
                            className='upload-button'
                            variant='contained'
                            onClick={openUploadMediaDialog}
                        >
                            + {generalStore.translate('uploadMedia')}
                        </Button>
                        </span>
                </span>
            </div>

            <Divider style={{color: "#C2C9DB", border: "1px solid #C2C9DB"}} variant='middle' orientation='horizontal'/>
            <div className='search-container' style={{maxWidth: panelWidth}}>
                <Input inputRef={inputRef} value={searchItems} className='search-field' endAdornment={<SearchIcon/>}
                       onChange={(e) => {
                           if (searchInFolder && projectStore.mediaLibraryPathArray.length !== 1) {
                               setSearchItems(e.target.value);
                               const searchResults = searchFilesInCurrentFolderAndSubfolders(e.target.value, allFolders, allFiles, currentFolder.folderId);
                               setCurrentFolderFoldersSearch(searchResults.foldersResults);
                               setCurrentFolderFilesSearch(searchResults.filesResults);
                           } else {
                               setSearchItems(e.target.value);
                               setCurrentFolderFoldersSearch(allFolders.filter(folder => folder.FolderName.toLowerCase().includes(e.target.value.toLowerCase())));
                               setCurrentFolderFilesSearch(allFiles.filter(file => file.FileName.toLowerCase().includes(e.target.value.toLowerCase())))
                           }
                       }} id="outlined-basic" placeholder="Search" disableUnderline/>

            </div>
            <div style={{maxWidth: panelWidth}}><span
                style={{marginTop: "10px"}}>{generalStore.translate('SearchInThisFolder')}</span><Checkbox
                checked={searchInFolder}
                onChange={() => setSearchInFolder(!searchInFolder)}/>
            </div>
            <div className='files-and-preview-container'>
                {RichObjectTreeView(rootFolders, goToFolder, allFoldersParentsMap, panelWidth, allFolders)}
                <Draggable axis="none" onDrag={handleDrag}>
                    <Divider
                        style={{color: "#C2C9DB", border: "1px solid #C2C9DB", cursor: "e-resize", marginTop: "-6%"}}
                        variant='middle' orientation='vertical'/>
                </Draggable>
                <div className={`files-container ${items.length > 0 ? 'selected-files' : ''}`}>
                    <span style={{display: "flex", flexDirection: "row"}}>
                    {renderTabs()}
                        </span>
                    {renderTabPanels()}
                </div>
                <Divider style={{color: "#C2C9DB", border: "1px solid #C2C9DB", marginTop: "-6%"}}
                         variant='middle' orientation='vertical'/>
                <ConditionalComponent if={!!items.length}>
                    <div className='file-preview-container hide-in-mobile'>
                        <ItemsPreview
                            items={items}
                            refreshMediaLibrary={refreshMediaLibrary}
                            selectedFiles={selectedFiles}
                        />
                    </div>
                </ConditionalComponent>
            </div>
            <ConditionalComponent if={!!modalStore.modalData.onMediaSelected}>
                <Button
                    className='save-selection'
                    onClick={saveSelection}
                    variant='contained'
                    disabled={!!isSaveDisabled()}
                >
                    {generalStore.translate('saveSelection')}
                </Button>
            </ConditionalComponent>
            {renderContextMenu()}
        </div>
    )
});

export default MediaLibrary;
